import type { SeriesKey } from './chart-series.ts';
import styles from './Chart.module.css';

export const ChartLegend = ({ keys }: { keys: readonly SeriesKey[] }) => (
  <ul className={styles['legend']}>
    {keys.map((key) => (
      <li key={key.key}>
        <span
          className={styles['key']}
          data-mark={key.mark}
          style={{ color: key.color }}
          aria-hidden="true"
        />
        {key.label}
      </li>
    ))}
  </ul>
);
